import { nanoid, customAlphabet } from 'nanoid'
import React, { Component } from 'react'
// import inputComponents from '../components/inputs/inputComponents';
import SidebarView from '../components/SidebarView';
import { getBoundingClientRect } from '../utils/functions';
import { checkTranslation, getObject, imageAddress, setObject, textVariableReplacer, translate } from '../utils/useful';
import FormViewer from '../components/FormViewer';
import ButtonAnimated from '../components/buttons/ButtonAnimated';
import ComponentFloatConfig from '../components/inputs/ComponentFloatConfig';
import { changeSelectedTextEffects, insertTextInEditor } from '../variables/notebook';
import PageBuilderAddElements from './PageBuilderAddElements';
import FixedView from '../components/FixedView';
import MenuToolbar from '../components/header/MenuToolbar';
import { saveAs } from 'file-saver';
import HttpServices from '../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import { ReactToPrint } from 'react-to-print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const generateLetterOnlyId = customAlphabet("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", 10);

// import importedIcons from '../components/inputs/icons';
// import { CalcResize } from '../components/dynamicDashboard/CalcReisze';
// import BaseAdminView from './Applets/BaseAdminView';
// import PageViewer from './PageViewer';
// import { this.props.typesObject } from '../variables/formBuilderData';
// import PageBuilderHeader from './PageBuilderHeader'


class PageBuilderMain extends Component {
    state = {
        content: [],
        colView: true,
        currentData: {},
        currentMedia: 'lg',
        medias: ["xs", "md", "lg"],
        pageId: generateLetterOnlyId(),
        componentSizes: {},

        container: {

            widths: {
                576: 540,
                768: 720,
                992: 960,
                1200: 1140,
                1400: 1320,
                1600: 1520,
            },

            containerMaxWidth: 1520,
            paddingRight: 12,
            paddingLeft: 12,

        },

        colResizeArrows: [
            // { direction: 'nw', style: { top: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', background: '', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
            // { direction: 'ne', style: { top: this.props.lang == 'en' ? '-1px' : '1px', right: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
            // { direction: 'sw', style: { bottom: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
            // { direction: 'se', style: { right: this.props.lang == 'fa' ? -12 : -12, bottom: -12, background: '#fff', border: '1px solid #999', width: 12, height: 12, borderRadius: 10, zIndex: 2 } },
            // { direction: 'top', style: {} },
            { direction: 'bottom', style: { borderRadius: 10, zIndex: 2, height: 8, width: '60%', minWidth: 8, maxWidth: 22, left: 'calc(50% - 11px)', bottom: -3, background: '#fff', border: '1px solid #007aff', } },
            // { direction: 'left', style: {} },
            { direction: 'right', style: { right: this.props.lang == 'fa' ? -3 : -3, borderRadius: 10, zIndex: 2, width: 8, maxHeight: 22, minHeight: 8, height: '60%', background: '#fff', border: '1px solid #007aff', top: 'calc(50% - 11px)', } },
        ],

        ltrResizeArrows: [
            // { direction: 'nw', style: { top: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', background: '', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
            // { direction: 'ne', style: { top: this.props.lang == 'en' ? '-1px' : '1px', right: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
            // { direction: 'sw', style: { bottom: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
            { direction: 'se', style: { right: this.props.lang == 'fa' ? '4px' : '-2px', bottom: -2, background: '#fff', border: '1px solid #007aff', width: 12, height: 12, borderRadius: 10, zIndex: 3 } },
            // { direction: 'nw', style: { top:-3 ,left:-3, bottom: -2, background: '#fff', border: '1px solid #007aff', width: 12, height: 12, borderRadius: 10, zIndex: 3 } },
            { direction: 'bottom', style: { border: '1px solid #007aff', borderRadius: 10, zIndex: 3, height: 8, width: '60%', minWidth: 8, maxWidth: 22, left: 'calc(50% - 11px)', bottom: -3, background: '#fff', border: '1px solid #007aff', } },
            { direction: 'top', style: { border: '1px solid #007aff', borderRadius: 10, zIndex: 3, height: 8, width: '60%', minWidth: 8, maxWidth: 22, left: 'calc(50% - 11px)', top: -3, background: '#fff', border: '1px solid #02c258', } },
            { direction: 'left', style: { left: this.props.lang == 'fa' ? -3 : -3, borderRadius: 10, zIndex: 3, width: 8, maxHeight: 22, minHeight: 8, height: '60%', background: '#fff', border: '1px solid #02c258', top: 'calc(50% - 11px)', } },

            // { direction: 'left', style: {} },
            { direction: 'right', style: { right: this.props.lang == 'fa' ? -3 : -3, borderRadius: 10, zIndex: 3, width: 8, maxHeight: 22, minHeight: 8, height: '60%', background: '#fff', border: '1px solid #007aff', top: 'calc(50% - 11px)', } },
        ],



        rtlResizeArrows: [
            // { direction: 'nw', style: { top: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', background: '', border: '1px solid #007aff', borderRadius: 1, zIndex: 3 } },
            // { direction: 'ne', style: { top: this.props.lang == 'en' ? '-1px' : '1px', right: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 3 } },
            // { direction: 'sw', style: { bottom: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 3 } },
            { direction: 'se', style: { right: this.props.lang == 'fa' ? '4px' : '-2px', bottom: -2, background: '#fff', border: '1px solid #007aff', width: 12, height: 12, borderRadius: 10, zIndex: 3 } },
            // { direction: 'nw', style: { top:-3 ,left:-3, bottom: -2, background: '#fff', border: '1px solid #007aff', width: 12, height: 12, borderRadius: 10, zIndex: 3 } },
            { direction: 'bottom', style: { border: '1px solid #007aff', borderRadius: 10, zIndex: 3, height: 8, width: '60%', minWidth: 8, maxWidth: 22, left: 'calc(50% - 11px)', bottom: -3, background: '#fff', border: '1px solid #007aff', } },
            { direction: 'top', style: { border: '1px solid #007aff', borderRadius: 10, zIndex: 3, height: 8, width: '60%', minWidth: 8, maxWidth: 22, left: 'calc(50% - 11px)', top: -3, background: '#fff', border: '1px solid #02c258', } },
            { direction: 'left', style: { right: -3, borderRadius: 10, zIndex: 3, width: 8, maxHeight: 22, minHeight: 8, height: '60%', background: '#fff', border: '1px solid #02c258', top: 'calc(50% - 11px)', } },

            // { direction: 'left', style: {} },
            { direction: 'right', style: { left: -3, borderRadius: 10, zIndex: 3, width: 8, maxHeight: 22, minHeight: 8, height: '60%', background: '#fff', border: '1px solid #007aff', top: 'calc(50% - 11px)', } },
        ],

        // resizeArrows: [
        //     // { direction: 'nw', style: { top: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', background: '', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
        //     // { direction: 'ne', style: { top: this.props.lang == 'en' ? '-1px' : '1px', right: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
        //     // { direction: 'sw', style: { bottom: this.props.lang == 'en' ? '-1px' : '1px', left: this.props.lang == 'en' ? '-1px' : '1px', border: '1px solid #007aff', borderRadius: 1, zIndex: 2 } },
        //     { direction: 'se', style: { right: this.props.lang == 'fa' ? 8 : 8, bottom: 8, background: '#fff', border: '1px solid #007aff', width: 12, height: 12, borderRadius: 10, zIndex: 2 } },
        //     // { direction: 'top', style: {} },
        //     { direction: 'bottom', style: { border: '1px solid #007aff', borderRadius: 10, bottom: 8,zIndex: 2, height: 8, width: '60%', minWidth: 8, maxWidth: 22, left: 'calc(50% - 11px)',  background: '#fff', border: '1px solid #007aff', } },
        //     // { direction: 'left', style: {} },
        //     { direction: 'right', style: { right: this.props.lang == 'fa' ? 8 : 8, borderRadius: 10, zIndex: 2, width: 8, maxHeight: 22, minHeight: 8, height: '30%', background: '#fff', border: '1px solid #007aff', top: 'calc(50% - 11px)', } },
        // ],

    }

    componentDidMount() {

        if (this.props.initData) {
            if (this.props.initData) {
                // this.setState({ content: JSON.parse(JSON.stringify(this.props.initData)) })
                this.setState({ content: this.props.initData })

            }
            if (this.props.userView) {
                // console.log('this.state.content', this.props.initData[0].children[0].children[0])
                // this.setState({ selectedSection: this.props.initData[0].children[0].children[0] })

            }
            // this.createComponents()

        }

        this.checkWidth()
        this.init()

        let isRTL = false
        if (document.body.classList.contains('rtl')) {
            isRTL = true
        }

        let resizeArrows = this.state.ltrResizeArrows
        if (isRTL) {
            resizeArrows = this.state.rtlResizeArrows
        }
        this.setState({ resizeArrows, isRTL })


    }

    componentDidUpdate(prevProps, prevState) {

        // console.log(JSON.stringify(prevState.content), this.state.content)

        // TO DO: Not efficient 
        if (this.props.liveChange) {
            this.props.liveChange()
        }

        if (JSON.stringify(prevState.content) !== JSON.stringify(this.state.content)) {

            // console.log(JSON.stringify(prevState.content) )
            // console.log(JSON.stringify(this.state.content) )

            // if (this.state.contentString !== JSON.stringify(this.state.content)) {

            // console.log("HERE")
            if (prevState.content?.length > 0) {
                this.setState({ colView: false }, () => {
                    this.setState({ colView: true })
                })
            }

            // if (this.props.liveChange) {
            //     this.props.liveChange()
            // }

        }
        if (prevProps.initData != this.props.initData) {
            this.setState({ content: this.props.initData }, () => {
                this.getComponentsSize()
            })

            // this.createComponents()
            if (this.props.userView) {
                // console.log('this.state.content', this.props.initData[0])
                if (Array.isArray(this.props.initData) && this.props.initData[0]?.children) {
                    this.setState({ selectedSection: this.props.initData[0].children[0].children[0] })
                }

            }
        }

        if (this.props.width != prevProps.width) {
            this.checkWidth()
        }

        if (JSON.stringify(this.props.page) != JSON.stringify(prevProps.page)) {

            this.init()
        }
    }

    init = () => {

        // if (this.props.page) {
        this.secContainerMaxWidth()
        if (this.props.setHeader) {
            // console.log(this.props.editMode)
            if (this.props.editMode) {
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    toolbarPadding: 10,
                    topHeaderComponent: this.topHeaderComponent,
                    headerIdentityComponent: this.headerIdentityComponent,
                    backAction: () => this.props.changePage('pages')
                })

            } else {

                this.props.setHeader({
                    'toolbar': this.toolbarView,
                    toolbarPadding: 10,
                    'showToolbar': this.props.showToolbar || this.props.page?.menu?.active,
                    title: this.props.name
                    // topHeaderComponent: this.topHeaderComponent,
                    // headerIdentityComponent: this.ViewHeaderIdentityComponent,
                    // backAction: () => this.props.changePage('pages')
                })

            }

            setTimeout(() => {
                this.setState({ revealFixed: true }, () => {
                    this.props.setHeader("dummy", 1)
                })
            }, 50);
        }
        // }
    }



    secContainerMaxWidth = () => {

        let maxWidth = 0
        let width = this.props.width

        for (const [key, value] of Object.entries(this.state.container.widths)) {
            if (width >= key) {
                maxWidth = value
            }
        }

        this.setState({ containerMaxWidth: maxWidth })

    }



    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input onChange={(e) => this.props.setName(e.target.value)} required={true} value={this.props.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} />
            </div>
        )
    }


    ViewHeaderIdentityComponent = () => {
        return (
            <div className='px-1' >
                <div className=' d-flex flex-column' style={{ color: this.props.colors?.textColor }}>
                    <p className="text-semibold text-small">{checkTranslation(this.props.name)}</p>
                </div>
            </div>
        )
    }



    toolbarView = () => {
        return (
            <div className='px-2 w-100'>
                <MenuToolbar setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} permissions={this.props.permissions} isMobile={this.props.isMobile} functionsHandler={this.functionsHandler} colors={this.props.colors} language={this.props.language} frame={this.props.page} width={this.props.width} />
            </div>
        )
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>


                <button onClick={() => this.plusFixedView.showView()} ref={el => this.plusBut = el} className="br-30 flexcc" style={{ backgroundColor: '#fff', height: 30, width: 30 }}>
                    <img src="/assets/icons/useful/more.png" className="rorate-90" height={20} alt='' />
                </button>
                {this.state.revealFixed && (
                    <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={7} maxWidth={200} >
                        <div className='bg-white br-10 py-2 px-2 shadow-3 sc-gray2 d-flex flex-column'>

                            <p className="text-smaller text-bold   ">{translate('Change view')}</p>


                            <div className='flexcb  mt-2'>

                                <div className='text-center'>
                                    <button className=" p-0 text-start flexc flex-column  br-4 px-2 py-2" onClick={() => this.changeMedia('lg')} style={{ backgroundColor: this.state.currentMedia == 'lg' ? '#f0f0f0' : null }}>
                                        <img src='/assets/icons/useful/computer.png' height={20} alt='' />
                                        <p className="font-size-11 text-semibold  mt-1 ">{translate('Desktop')}</p>
                                    </button>
                                    {/* <p className="font-size-10 color-gray-1  mt-1 ">{translate('≥992px')}</p> */}
                                </div>
                                <div className='text-center'>
                                    <button className=" p-0 text-start flexc flex-column mx-1 br-4 px-2 py-2" onClick={() => this.changeMedia('md')} style={{ backgroundColor: this.state.currentMedia == 'md' ? '#f0f0f0' : null }}>
                                        <img src='/assets/icons/useful/tablet.png' height={20} alt='' />
                                        <p className="font-size-11 text-semibold  mt-1 ">{translate('Tablet')}</p>
                                    </button>
                                    {/* <p className="font-size-10 color-gray-1  mt-1 ">{translate('576px≥x<576px')}</p> */}

                                </div>

                                <div className='text-center'>
                                    <button className=" p-0 text-start flexc flex-column  br-4 px-2 py-2" onClick={() => this.changeMedia('xs')} style={{ backgroundColor: this.state.currentMedia == 'xs' ? '#f0f0f0' : null }}>
                                        <img src='/assets/icons/useful/phone.png' height={20} alt='' />
                                        <p className="font-size-11 text-semibold  mt-1 ">{translate('Mobile')}</p>
                                    </button>
                                    {/* <p className="font-size-10 color-gray-1  mt-1 ">{translate('<576px')}</p> */}
                                </div>


                            </div>



                            {/* <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.data)}>
                            <img src='/assets/icons/useful/star (9).png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Make as default')}</p>
                        </button>

                        <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.data)}>
                            <img src='/assets/icons/useful/directions.png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Convert to advance')}</p>
                        </button> */}

                            <div className="w-100 my-2" style={{ height: 1, background: "#eee" }}>

                            </div>

                            <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.toggleNavigationMenu()}>
                                <img src='/assets/icons/useful/menu.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Nevigation menu')}</p>
                            </button>

                            <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.togglePermissions()}>
                                <img src='/assets/icons/useful/key-access.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Permissions and access')}</p>
                            </button>

                            <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.toggleConfig()}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Page settings')}</p>
                            </button>


                            <div className="w-100 my-2" style={{ height: 1, background: "#eee" }}>

                            </div>

                            <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.togglePublish()}>
                                <img src='/assets/icons/useful/share.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Publish as template')}</p>
                            </button>


                        </div>
                    </FixedView>
                )}



                <div className='mx-1' style={{ zIndex: 22 }} >
                    {/* {console.log('this.state.componentsInfo',this.state.componentsInfo)} */}
                    <PageBuilderAddElements type={this.state.type} componentsInfo={this.props.componentsInfo} onDragStartAction={this.onDragStartAction} applet={this.props.applet} colors={this.props.colors} variables={this.props.variables} />
                </div>

                {/* <div className='flexcc px-1'>
                    <button className={" pl-2 prd-5 py-2 flexc br-20 " + " add-element "} onClick={() => this.toggleConfig()}>
                        <img className='prd-1 invert' width={22} src='/assets/icons/applets/database/setting-white.svg' />
                        <p className='font-size-14 black weight-500'>{translate('Config')}</p>
                    </button>
                </div> */}


                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.state.isLoadingData ? () => { } : () => this.save()}
                    title='Save'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    isLoading={this.state.isLoadingData}
                />

            </div>
        )
    }

    save = () => {
        this.setState({ isLoadingData: true }, () => {
            if (this.props.setHeader) {
                this.props.setHeader("dummy", 1)
            }
        })
        this.props.save(() => {
            this.setState({ isLoadingData: false }, () => {
                if (this.props.setHeader) {
                    this.props.setHeader("dummy", 1)
                }
            })
        })
    }






    getComponentsSize = () => {

        if (this.state.pageId) {

            let pageElement = document.querySelector(`.${this.state.pageId}`)

            if (pageElement) {
                let elements = document.querySelectorAll(`.${this.state.pageId} .builder-component-container.main-container`)

                let componentSizes = {}

                for (let i = 0; i < elements.length; i++) {
                    const element = elements[i];
                    let id = element.id
                    if (id) {
                        let size = getBoundingClientRect(element)
                        componentSizes[id] = { width: size.width, height: size.height }
                    }
                }


                this.setState({ componentSizes })
            }

        }
    }


    checkWidth = () => {

        let media = this.props.media ?? 'lg'
        let width = this.props.width

        if (width <= 780 && this.props.media != 'xs') {
            media = 'md'
        }

        if (width <= 550) {
            media = 'xs'
        }

        this.setState({ currentMedia: media }, () => {
            if (this.props.setHeader) {
                this.props.setHeader("dummy", 1)

            }

            this.getComponentsSize()

        })

        this.secContainerMaxWidth()
    }


    findBounds = (content) => {
        let components = {}
        let bounds = {}
        // let content = this.state.content
        this.findComponents(content, components, bounds)

        return bounds
        // console.log(components)
        // this.setState({ components })
    }


    findComponents = (children, components, bounds) => {

        // console.log("findComponents", children)

        if (Array.isArray(children)) {
            children.forEach(section => {
                // console.log(this[section.id])
                // console.log(bounds)

                if (this[section.id]) {
                    if (!bounds) {
                        bounds = {}
                    }
                    bounds[section.id] = getBoundingClientRect(this[section.id])
                }

                // if (section.type != 'column' && section.type != 'row') {


                //     // let Component = this.props.componentsInfo.components[section.type]
                //     // let data = section?.information
                //     // let header = section ?? { key: section.id, id: section.id, information: {} }

                //     components[section.id] = section//() => { return <Component actions={this.state.actions} page={this.props.page} permissions={this.props.permissions} section={section} editorId={section.id} changeValue={(key, value, extra) => this.changeSectionValue('content', value, extra, section)} data={data} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} width={this.props.width} params={this.props.params} changeWindowLink={this.props.changeWindowLink} addNewWindow={this.props.addNewWindow} baseUrl={this.props.baseUrl ? [...this.props.baseUrl] : null} windowData={this.props.windowData} colors={this.props.colors} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} userView={this.props.userView} editMode={this.props.editMode} functionsHandler={this.functionsHandler} /> }

                // }


                // console.log('pass', section.children)


                if (Array.isArray(section.children)) {
                    this.findComponents(section.children, components, bounds)
                }
            })

        }
    }


    getComponentValue = (content, id, key) => {

        if (Array.isArray(content)) {

            // content.forEach(section => {
            for (let i = 0; i < content.length; i++) {
                const section = content[i];


                if (section.id == id) {
                    return getObject(section, key)

                } else {

                    if (Array.isArray(section.children)) {
                        this.getComponentValue(section.children, id, key)
                    }
                }
            }
            // })



        }
    }


    componentWillUnmount() {
        window.removeEventListener('mouseup', this.onDrop)
        window.removeEventListener('mousemove', this.mouseMoved)
    }

    onDrop = (e, mouse) => {

        // console.log("*******onDrop")
        e.preventDefault();
        e.stopPropagation()
        // console.log(e)
        // e.target.style.border = "1px dashed #eee"
        // e.target.style.backgroundColor = "transparent";
        // e.target.style.background = "none";


        // let dragData;
        // if (e.dataTransfer.getData) {
        //     dragData = e.dataTransfer.getData("dragData");
        // } else {
        //     dragData = e.dataTransfer;
        //     dragData = JSON.stringify(dragData);
        // }
        let content = this.state.content

        if (this.state.movingSection) {
            this.doRemoveElement(content, { ...this.state.movingSection }, [...this.state.movingSection.parents])
        }
        let dropZone = this.state.dropZone

        if (dropZone) {

            let id = nanoid()
            let key = id
            let type
            let currentApplet
            let information = {}
            let element

            // console.log(this.state.movingSection)
            // console.log(e.dataTransfer.getData('type'))

            if (!this.state.movingSection) {
                if (e.dataTransfer.getData) {
                    // id = e.dataTransfer.getData('id')
                    type = e.dataTransfer.getData('type')
                    currentApplet = e.dataTransfer.getData('currentApplet')
                } else {
                    // id = e.dataTransfer.id
                    type = e.dataTransfer.type
                    currentApplet = e.dataTransfer.currentApplet

                }

                if (this.props.componentsInfo.object[type]) {
                    this.props.componentsInfo.object[type].headers.forEach(header => {
                        information[header.key] = header.information?.defaultValue
                    });
                }
                // console.log('this.props.componentsInfo.object[type]', this.props.componentsInfo.object[type])
                // console.log('information[header.key]', information)
                if (currentApplet) {
                    information.applet = currentApplet
                }

                // console.log(type)
                // console.log(information)

                element = { id, key, type: type, information: information, parents: dropZone.parents }

            } else {
                element = { ...this.state.movingSection }
            }


            // console.log(element)

            if (element) {

                this.doAddElement(content, element, dropZone.parents, this.state.dropZone?.target, this.state.dropZone?.position)

            }

            // console.log('content', content)
            // console.log('dropZone.parents', dropZone.parents)


            setTimeout(() => {
                this.doRemoveElement(content, this.state.dropZone, this.state.dropZone?.parents, this.state.dropZone?.target, this.state.dropZone?.position)
                setTimeout(() => {
                    this.removeTempType(this.state.dropZone?.parents)

                    // this.fixComponentSizes(content, dropZone.parents, element)
                    // console.log('content', content)

                    this.setState({ content, dropZone: null, }, () => {
                        this.getComponentsSize()
                    })
                    setTimeout(() => {
                        this.setState({ movingSection: null, isDragging: false, isOnDraging: false, })
                    }, 100);
                }, 1);
            }, 1);
            window.removeEventListener('mouseup', this.onDrop)
            this.setState({ elementBeforeMove: null, elementAfterMove: null, isDragging: false })
            window.removeEventListener('mousemove', this.mouseMoved)

        }

        // this.doAddElement(e, element, parents, row, column, position)

    }


    fixComponentSizes = (content, parents, newElement) => {

        // console.log("fixComponentSizes")

        this.secContainerMaxWidth()
        if (Array.isArray(content)) {


            content.forEach(section => {
                let found = false
                let last = false

                parents.forEach((parent, index) => {
                    if (section.id == parent.id) {
                        found = true
                        // console.log("FOUND")
                        // console.log(index,parents.length)

                        let lastParentId = newElement.parents[newElement.parents.length - 2]?.id

                        if (section.id == lastParentId) {
                            last = true
                        }
                        // if (index == parents.length - 1) {
                        //     last = true
                        //     // console.log("LAST")
                        // }

                    }
                })

                let finalSize = {}

                if (last && found && section.type == 'row' && Array.isArray(section.children)) {

                    // console.log("section", section)
                    // console.log("parents", parents)
                    // console.log("newElement", newElement)

                    let newColumn


                    ["xs", "md", "lg"].forEach(media => {


                        let totalMin = 0
                        let totalSuitable = 0
                        let currentTotal = 0
                        let totalMax = 0
                        let childrenSizes = []
                        let newLimits = {}


                        section.children.forEach(column => {

                            let childMin = 0
                            let childSuitable = 0
                            let childMax = 0
                            let isNew = false
                            let currentSize = column?.style?.width
                            if (currentSize && typeof currentSize == 'object') {
                                currentSize = currentSize[media]
                            }

                            column.children.forEach(child => {

                                let refComponent = this.props.componentsInfo.object[child.type]
                                let refSizes

                                if (refComponent) {
                                    refSizes = refComponent.sizes
                                }


                                if (!refSizes) {
                                    refSizes = {
                                        min: { xs: 50, md: 20, lg: 10 },
                                        suitable: { xs: 100, md: 100, lg: 100 },
                                        max: { xs: 100, md: 100, lg: 100 },
                                    }

                                }



                                childMin = (refSizes.min[media] ?? 0) > childMin ? (refSizes.min[media] ?? 0) : childMin
                                childSuitable = (refSizes.suitable[media] ?? 0) > childSuitable ? (refSizes.suitable[media] ?? 0) : childSuitable
                                childMax = (refSizes.max[media] ?? 100)

                                if (child.id == newElement.id) {
                                    isNew = true
                                    newLimits = { min: childMin, suitable: childSuitable, max: childMax }
                                }

                            });

                            totalMin = totalMin + childMin
                            totalSuitable = totalSuitable + childSuitable

                            if (!currentSize) {
                                currentSize = childMin
                            }

                            if (!isNew) {
                                currentTotal = currentTotal + currentSize
                            } else {
                                if (column.children.length == 1) {
                                    newColumn = column.id
                                }
                            }

                            childrenSizes.push({ min: childMin, suitable: childSuitable, current: currentSize, isNew })
                            // childMax = childMax + (refSizes.max[media] ?? 0)


                        })

                        if (newColumn) {

                            if (totalMin > 100) {

                                // TO DO

                            } else {

                                section.children.forEach((child, k) => {

                                    if (!finalSize[child.id]) {
                                        finalSize[child.id] = {}
                                    }

                                    if (currentTotal + newLimits.min <= 100) {

                                        if (child.id == newColumn) {
                                            finalSize[child.id][media] = 100 - currentTotal
                                        } else {
                                            finalSize[child.id][media] = childrenSizes[k].current
                                        }

                                    } else {

                                        finalSize[child.id][media] = Math.floor((100 / childrenSizes.length) * 100) / 100

                                    }

                                })
                            }
                        }

                    })

                    // console.log("finalSize", finalSize)

                    if (newColumn) {

                        section.children.forEach(column => {

                            if (!column.style) {
                                column.style = {}
                            }
                            column.style.width = finalSize[column.id]

                        })
                    }


                } else {
                    this.fixComponentSizes(section.children, parents, newElement)
                }

            })

        }
    }








    removeTempType(parents) {
        let content = this.state.content
        this.changeObjectContentParam(content, parents, 0, 'temp', false)
        this.setState({ content })
    }

    changeObjectContentParam(content, parents, index, key, value) {

        // console.log('**changeObjectContentParam',content, parents, index, key, value)

        if (parents) {
            if (parents.length > index) {
                if (content) {
                    let found
                    // console.log(content)
                    content.forEach((element, eindex) => {
                        if (element.id == parents[index]?.id) {
                            found = eindex
                            element[key] = value
                            // console.log("Change")
                        }
                    });

                    if (found != null) {
                        this.changeObjectContentParam(content[found].children, parents, index + 1, key, value)
                    }
                }
            }

        }
    }





    onDragLeave = (e, innerLine) => {
        // if (this.props.rowContent == 0) {
        //     // e.target.style.background = "rgb(245, 240, 240)";
        //     // this.rowRef.style.border = "1px dahsed transparent";
        //     e.target.style.border = "1px dashed #eee"
        //     e.target.style.backgroundColor = "transparent";
        // } else {
        //     // innerLine.style.visibility = 'visible'
        //     e.target.style.border = "1px dashed #eee"
        //     e.target.style.background = "none";
        // }
    };

    onDragStartAction = (e, type) => {
        let baseContent = JSON.parse(JSON.stringify(this.state.content))
        // console.log(baseContent)
        this.setState({ isDragging: true, selectedSection: null, baseContent, draggingType: type })
    }


    onMouseOver = (e, parents, target, position) => {
        if (this.state.movingSection) {
            this.onDragEnter(e, parents, target, position)
        }
    }


    onDragEnter = (e, parents, target, position) => {
        e.preventDefault();

        // console.log("****onDragEnter")
        // console.log("Target, ", target)

        // if (this.props.rowContent == 0) {
        //     // this.rowRef.style.border = "1px dahsed #6D79CC";
        //     e.target.style.background = "#eee";
        //     e.target.style.border = "1px dashed #007aff"
        //     // this.dropText.style.backgroundColor = "red";
        // } else {
        //     // innerLine.style.visibility = 'hidden'
        //     // this.rowRef.style.border = "rgb(245, 240, 240) !important";
        //     e.target.style.border = "1px dashed #007aff"
        //     e.target.style.background = "linear-gradient(to left, #eee, #f2f6f8 )";
        // }

        // if (!this.state.dropZone || this.state.dropZone?.column != column || this.state.dropZone?.row != row) {
        // console.log(target)
        // if (this.currentTarget?.position != target.position && this.currentTarget?.id != target.id) {

        // console.log(this.currentTarget,target)

        // console.log(target)
        if (!this.state.isOnDraging) {
            this.currentTarget = target

            // if (!this.currentTarget && !this.state.lockOnDragEnter) {

            this.setState({ currentTarget: target })

            setTimeout(() => {
                // this.currentTarget = null
                if (this.currentTarget == target) {
                    this.doGragOnEffect(e, parents, target, position)
                }
            }, 200);
        }
        // }



        // }

    };



    doGragOnEffect = (e, parents, target, position) => {
        if (!this.state.isOnDraging) {
            this.setState({ isOnDraging: true })

            let content = this.state.content
            let id = nanoid()


            if (!parents) {
                parents = parents ? parents : []
            }


            if (!target || target.type == 'row') {

                let rowId = nanoid()

                if (parents[parents.length - 2] != rowId) {
                    parents.push({ id: rowId, type: 'row', temp: true })
                }

                // console.log("New Row => ", rowId)

            }

            if (!target || target.type == 'row' || target.type == 'column') {

                let columnId = nanoid()

                if (parents[parents.length - 1] != columnId) {
                    parents.push({ id: columnId, type: 'column', temp: true })
                }
            }

            let elementBeforeMove
            let elementAfterMove
            let promises = []



            let bounds = this.findBounds(content)

            // if (this.state.elementBeforeMove) {
            //     console.log(JSON.parse(JSON.stringify(this.state.elementBeforeMove)))
            // }
            // if (this.state.elementAfterMove) {
            //     console.log(JSON.parse(JSON.stringify(this.state.elementAfterMove)))
            //     console.log(JSON.parse(JSON.stringify(content)))

            // }

            // console.log("target", JSON.parse(JSON.stringify(target)))

            let beforMoveIndex

            if (this.state.elementAfterMove && this.state.elementBeforeMove) {

                // let moveTarget = {}


                promises.push(new Promise((resolve, reject) => {

                    // console.log("moveElement", this.state.beforMoveIndex)
                    // console.log("content", JSON.parse(JSON.stringify(content)))

                    // this.state.beforMoveIndex

                    this.moveElement(content, [...this.state.elementAfterMove.parents], [...this.state.elementBeforeMove.parents], this.state.elementAfterMove, target, this.state.beforMoveIndex, () => {
                        // beforMoveIndex = bmi
                        // console.log("========",)
                        resolve()
                    })
                }))

            }





            Promise.all(promises).then(() => {

                let newPromises = []

                if ((target && target?.type != 'row' && target?.type != 'column') && (target.position == 'left' || target.position == 'right')) {
                    newPromises.push(new Promise((resolve, reject) => {

                        let rowId = nanoid()
                        let columnId = nanoid()
                        let columnTaregtId = nanoid()


                        parents.push({ id: rowId, type: 'row', temp: true })
                        parents.push({ id: columnId, type: 'column', temp: true })

                        elementBeforeMove = JSON.parse(JSON.stringify(target))
                        // console.log("elementBeforeMove", elementBeforeMove)

                        let targetNewParents = [...target.parents]
                        targetNewParents.push({ id: rowId, type: 'row', temp: true })
                        targetNewParents.push({ id: columnTaregtId, type: 'column', temp: true })

                        this.findCurrentIndex(content, elementBeforeMove, 0, (bmi) => {

                            // console.log("beforMoveIndex", bmi)

                            beforMoveIndex = bmi

                            this.moveElement(content, [...target.parents], targetNewParents, target, target)
                            // parents[parents.length - 1] = { id: columnId, type: 'column', temp: true }

                            // console.log("Move Element => ", columnId)

                            elementAfterMove = { ...target }
                            elementAfterMove.parents = targetNewParents

                            resolve()
                        })
                        // console.log("targetNewParents",targetNewParents)
                        // if (targetNewParents) {
                        //     console.log(JSON.parse(JSON.stringify(targetNewParents)))
                        // }
                        // if (target.parents) {
                        //     console.log(JSON.parse(JSON.stringify(target.parents)))
                        // }
                    }))

                }



                Promise.all(newPromises).then(() => {

                    // console.log("beforMoveIndex", beforMoveIndex)

                    this.setState({ elementBeforeMove, elementAfterMove, beforMoveIndex })

                    // content.push([{ id, type: 'ghost', config: {}, parents }])

                    // let element = { id, type: 'dropZone', config: {}, parents }

                    if (!this.state.dropZone || !target || this.state.dropZone?.target?.id != target?.id || this.state.dropZone?.target?.position != target?.position) {

                        // let type
                        // if (e.dataTransfer.getData) {
                        //     // id = e.dataTransfer.getData('id')
                        //     type = e.dataTransfer.getData('type')
                        // } else {
                        //     type = e.dataTransfer.type

                        // }

                        // console.log(e.dataTransfer?.getData)
                        // console.log(e.dataTransfer?.type)

                        let type = this.state.draggingType

                        let dropZone = { id, type: 'dropZone', finalType: type, config: {}, parents, target, position }


                        // console.log("Add Element", JSON.parse(JSON.stringify(content)))
                        // console.log("Target", target)
                        // console.log("parents", parents)


                        this.doAddElement(content, dropZone, parents, target, position, () => {

                        })
                        // console.log(parents)
                        dropZone.parents = [...parents]

                        // console.log("PreRemove Element, ", this.state.dropZone)
                        setTimeout(() => {
                            if (this.state.dropZone) {
                                this.doRemoveElement(content, this.state.dropZone, this.state.dropZone?.parents, target)

                                let originalDropParents

                                for (let v = 0; v < this.state.dropZone?.parents.length; v++) {
                                    const element = this.state.dropZone?.parents[v];


                                    if (element.type == 'row') {
                                        let baseContent = JSON.parse(JSON.stringify(this.state.baseContent))
                                        originalDropParents = this.getComponentValue(baseContent, element.id, 'children')
                                    }
                                }

                                // console.log("originalDropParents", originalDropParents)

                                if (Array.isArray(originalDropParents)) {
                                    for (let z = 0; z < originalDropParents.length; z++) {
                                        const original = originalDropParents[z];
                                        // console.log("original",original)

                                        this.changeParentValue(content, original.id, original.parents, 0, 'style.width', original?.style.width)

                                    }
                                }

                                this.checkCalculateNewColumn(content, dropZone)


                            } else {
                                this.checkCalculateNewColumn(content, dropZone)
                            }

                            this.setState({ dropZone, }, () => {

                                let newBounds = this.findBounds(content)


                                // console.log(newBounds)
                                this.animateMove(bounds, newBounds)


                                console.log(JSON.parse(JSON.stringify(content)))

                                setTimeout(() => {
                                    this.setState({ content, isOnDraging: false })
                                    // this.setState({ isOnDraging: false })

                                }, 350);

                            })

                        }, 0);


                    } else {
                        this.setState({ isOnDraging: false })
                    }

                })
            })
        }
    }


    findCurrentIndex = (content, element, index, cb) => {
        // console.log("findCurrentIndex")
        // console.log("element",JSON.parse(JSON.stringify(element)) )
        // console.log("content",JSON.parse(JSON.stringify(content)) )

        // content.forEach(data => {
        for (let i = 0; i < content.length; i++) {
            const data = content[i];

            if (element.parents[index]?.id == data.id) {

                if (index == element.parents.length - 1) {

                    data.children.forEach((child, j) => {
                        if (child.id == element.id) {
                            // console.log("beforMoveIndex", j)
                            cb(j)
                            // return j
                        }
                    })

                } else {
                    let newIndex = index + 1
                    this.findCurrentIndex(data.children, element, newIndex, cb)
                }
            }
        }
        // });
    }

    checkCalculateNewColumn = (content, dropZone, newInfoRef, element) => {

        let newColumn
        let myContent = content
        dropZone.parents.forEach(parent => {



            if (parent.temp && parent.type == 'column') {
                newColumn = parent
                // console.log("NEW COL")
            }
            if (!newColumn) {
                myContent.forEach(contentLevel => {
                    if (contentLevel.id == parent.id) {
                        myContent = contentLevel.children
                    }
                });
            }
        });

        if (newColumn && myContent) {

            this.calcColumnSizes(myContent, dropZone, newColumn)

            // console.log(JSON.parse(JSON.stringify(myContent)))
            // console.log(JSON.parse(JSON.stringify(content)))


        }
    }


    animateMove = (bounds, newBounds) => {

        requestAnimationFrame(() => {

            Object.keys(bounds).forEach(key => {

                let deltaX = (bounds[key]?.left ?? 0) - (newBounds[key]?.left ?? 0);
                let deltaY = (bounds[key]?.top ?? 0) - (newBounds[key]?.top ?? 0)
                let deltaW = (bounds[key]?.width ?? 0) - (newBounds[key]?.width ?? 0)
                let deltaH = (bounds[key]?.height ?? 0) - (newBounds[key]?.height ?? 0)

                if ((newBounds[key]?.width ?? 0) == 0) {
                    deltaX = 0
                    deltaY = 0
                }

                if (deltaX !== 0 || deltaY !== 0 || deltaW !== 0 || deltaH !== 0) {

                    let domNode = this[key]
                    if (domNode) {


                        domNode.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
                        domNode.style.width = (bounds[key]?.width ?? 0)
                        domNode.style.height = (bounds[key]?.height ?? 0)

                        domNode.style.transition = 'transform 0s';
                        requestAnimationFrame(() => {
                            // this.dragOverId = null
                            // In order to get the animation to play, we'll need to wait for
                            // the 'invert' animation frame to finish, so that its inverted
                            // position has propagated to the DOM.
                            //
                            // Then, we just remove the transform, reverting it to its natural
                            // state, and apply a transition so it does so smoothly.
                            domNode.style.transform = '';
                            domNode.style.width = (newBounds[key]?.width ?? 0)
                            domNode.style.height = (newBounds[key]?.height ?? 0)

                            domNode.style.transition = 'transform 300ms';

                        });

                        setTimeout(() => {
                            // this.setState({ lockOnDragEnter: false })
                        }, 300);

                    }

                }

            })
        })
    }



    moveElement(content, oldParents, newParents, element, target, initTargetIndex, cb) {
        // let content = [...this.state.content]
        // let targetIndex
        if (content) {

            this.addInNestedArray(content, element, 0, newParents, target, initTargetIndex, () => {
                // targetIndex = ti
            })

            this.removeFromNestedArray(content, element, 0, oldParents)

            // this.setState({ content }, () => {
            if (cb) {
                cb()
            }
            // })

        }


    }


    doRemoveElement(content, element, parents) {
        // console.log("** doRemoveElement")
        // console.log("element, ", element)
        // console.log("parents, ", parents)

        // let content = [...this.state.content]

        if (content) {
            if (element) {
                this.removeFromNestedArray(content, element, 0, parents)

                // this.setState({ content }, () => {
                //     // if (cb) {
                //     //     cb()
                //     // }
                // })
            }

        }


    }


    removeFromNestedArray(content, element, index, parents, cb) {
        // console.log(parents)
        // console.log(content)
        // console.log(parents)
        if (!parents || (parents.length) == index) {

            // console.log("Finish Remove")
            // console.log(content)
            // console.log(parents)
            // console.log(element.id)

            let found

            content.forEach((melement, mindex) => {
                if (element.id == melement.id) {
                    found = mindex
                }
            });

            // console.log(found)


            if (found != null && found != undefined) {
                // console.log("SPLICE")
                // console.log("removeFromNestedArray0",JSON.parse(JSON.stringify(content)),found)
                content.splice(found, 1)
                // console.log("removeFromNestedArray2",JSON.parse(JSON.stringify(content)),found)

            }

            if (cb) {
                cb()
            }

            // let columnId = column
            // if (!columnId) {
            //     columnId = nanoid()
            // }
            // content.push(element)


        } else {
            let found = null
            content.forEach((oneContent, nindex) => {
                // console.log(oneContent)
                // console.log(parents[index])

                if (oneContent.id == parents[index]?.id) {
                    found = nindex
                }
            });

            // console.log(index)
            // console.log(parents[index])
            // console.log("Found,", found)
            // console.log("oneContent,", oneContent)

            if (found != null && found != undefined) {


                this.removeFromNestedArray(content[found].children, element, index + 1, parents, () => {
                    // console.log('CB ', content[found].children.length)

                    if (content[found].children.length == 0) {
                        // console.log("** remove, ", JSON.stringify(content))
                        content.splice(found, 1)
                        // console.log("** remove1, ", JSON.stringify(content))
                        // console.log("removeFromNestedArray1",content,found)

                        if (cb) {
                            cb()
                        }
                    }
                })

            }


            // this.removeFromNestedArray(content[found].children, element, index + 1, parents, row, column, position)

        }
    }



    doAddElement(content, element, parents, target, position, cb) {
        // console.log("doAddElement")
        // console.log(parents)

        // let content = [...this.state.content]
        if (content == null) {
            content = []
        }

        this.addInNestedArray(content, element, 0, parents, target, null, (targetIndex) => {

            if (cb) {
                // console.log(targetIndex)
                cb(targetIndex)
            }
        })
        // requestAnimationFrame(() => {
        //     this.setState({ content }, () => {
        //         // if (cb) {
        //         //     cb()
        //         // }
        //     })
        // })

    }


    addInNestedArray(content, element, index, parents, target, targetIndex, cb) {

        // console.log("addInNestedArray", index, targetIndex, JSON.parse(JSON.stringify(parents)))

        // console.log("content, ", content)
        // console.log("parents, ", parents)
        // console.log("target, ", JSON.stringify(target))

        // console.log(JSON.parse(JSON.stringify(content)))
        // let newColumn
        // let newInfo

        if (parents.length == index) {


            this.pushToContent(content, element, index, parents, target, targetIndex)
            // if (cb) {
            //     cb()
            //     // console.log("targetIndex",targetIndex)
            // }


        } else {
            let parentIndex
            let targetParentIndex
            // let indexOfElement

            content.forEach((oneContent, nindex) => {

                if (oneContent.id == parents[index]?.id) {
                    parentIndex = nindex
                }
                if (oneContent.id == target?.id) {
                    targetIndex = nindex
                }

                if (oneContent.id == target?.parents[index]?.id) {
                    targetParentIndex = nindex
                }

            });

            // console.log("parentIndex, ", parentIndex)
            // console.log("targetIndex, ", targetIndex)
            // console.log("targetParentIndex, ", targetParentIndex)

            // console.log("parents[index]?.id, ", parents[index]?.id)
            // console.log("target?.parents[index]?.id, ", target?.parents[index]?.id)


            // console.log("parentIndex", parentIndex)

            if (parentIndex == null) {


                let tempIndex = targetIndex ?? (targetParentIndex ?? 0)

                // console.log("target?.position", target?.position)

                if (target?.position == 'top' || target?.position == 'left') {
                    content.splice(tempIndex, 0, { id: parents[index].id, children: [], type: parents[index].type, temp: parents[index].temp })
                    parentIndex = tempIndex
                } else {
                    content.splice(tempIndex + 1, 0, { id: parents[index].id, children: [], type: parents[index].type, temp: parents[index].temp })
                    parentIndex = tempIndex + 1

                }

                // console.log("addInNestedArray", JSON.parse(JSON.stringify(content)))
                // console.log("tempIndex", tempIndex)


                if (parentIndex == null || parentIndex > content.length) {
                    parentIndex = (content.length - 1)
                }
                if (content.length == 1) {
                    parentIndex = 0
                }

                // console.log("position!, ", target?.position)
                // console.log("tempIndex, ", tempIndex)

                // content.push({ id: parents[index].id, children: [], type: parents[index].type, temp: parents[index].temp })
                // parentIndex = (content.length - 1) ?? 0
            }



            // if (index == parents.length - 2) {
            //     // console.log("HERE", JSON.parse(JSON.stringify(content[parentIndex].children)))
            //     for (let d = 0; d < content[parentIndex].children.length; d++) {
            //         let colElement = content[parentIndex].children[d];

            //         if (colElement.type == 'column') {
            //             if (!colElement.style) {
            //                 colElement.style = {}
            //             }
            //             if (!colElement.style.width) {
            //                 colElement.style.width = {}
            //             }
            //             colElement.style.width = { lg: 33.33, md: 30, xs: 50 }


            //             console.log(JSON.parse(JSON.stringify(colElement)))
            //         }
            //     }
            //     // content[parentIndex].children.forEach((colElement, d) => {

            //     //     // console.log(colElement)
            //     //     if (!content[parentIndex].children[d].style) {
            //     //         content[parentIndex].children[d].style = {}
            //     //     }
            //     //     if (!content[parentIndex].children[d].style.width) {
            //     //         content[parentIndex].children[d].style.width = {}
            //     //     }
            //     //     content[parentIndex].children[d].style.width.lg = 20

            //     //     // if (!element.style) {
            //     //     //     element.style = {}
            //     //     // }

            //     //     // if (!element.style.width) {
            //     //     //     element.style.width = {}
            //     //     // }
            //     //     // element.style.width.lg = 20


            //     //     // console.log(colElement)

            //     // });
            // }

            // if (newColumn && parentContent && index == parents.length - 1 && content[parentIndex]?.type == 'column') {

            //     // if (parentContent) {

            //     // console.log("parentContent.children", parentContent.children.length, index,parentIndex)
            //     // console.log("parentContent.children", parentContent.children)

            //     // for (let d = 0; d < parentContent.children.length; d++) {
            //     //     const element = parentContent.children[d];

            //     //     if (!element.style) {
            //     //         element.style = {}
            //     //     }
            //     //     if (!element.style.width) {
            //     //         element.style.width = {}
            //     //     }
            //     //     let size = 100 / parentContent.children.length
            //     //     element.style.width = { lg: size, md: 30, xs: 50 }
            //     // }

            //     newInfo = { content: parentContent, column: newColumn }

            //     // console.log(element)
            //     // }

            //     // if (!content[parentIndex].style) {
            //     //     content[parentIndex].style = {}
            //     // }
            //     // if (!content[parentIndex].style.width) {
            //     //     content[parentIndex].style.width = {}
            //     // }
            //     // content[parentIndex].style.width = { lg: 33.33, md: 30, xs: 50 }

            // }

            // console.log(JSON.parse(JSON.stringify(content[parentIndex])))

            if (content[parentIndex]) {

                this.addInNestedArray(content[parentIndex].children, element, index + 1, parents, target, targetIndex, cb)
            } else {
                console.log("ERR")
            }
            // console.log("found!, ", found)
            // console.log("content, ", JSON.stringify(content))
            // console.log("content, ", content)

            // console.log(parents[index])
            // console.log("Found," ,found)

            // if (foundIndex != null) {
            //     this.pushToContent(content, element, index, parents, target, foundIndex)
            // } else {


            // }


        }
    }




    calcColumnSizes = (sections, newElement, newColumn) => {

        // console.log("calcColumnSizes", JSON.parse(JSON.stringify(sections)))


        if (Array.isArray(sections)) {
            let finalSize = {}
            // let newColumnIndex
            // let newColumn = false

            // console.log("section", JSON.parse(JSON.stringify(section)))
            // console.log("newElement", newElement)

            for (let i = 0; i < this.state.medias.length; i++) {
                const media = this.state.medias[i];

                // }

                // this.state.medias.forEach(media => {



                let totalMin = 0
                let totalSuitable = 0
                let currentTotal = 0
                // let totalMax = 0
                let childrenSizes = {}
                let newLimits = {}


                for (let j = 0; j < sections.length; j++) {
                    const column = sections[j];


                    // console.log("COL", column.id)
                    // }
                    // sections.forEach(column => {

                    let childMin = 0
                    let childSuitable = 0
                    let childMax = 0
                    let isNew = false
                    let currentSize = column?.style?.width

                    // console.log(column.id, currentSize)

                    if (currentSize && typeof currentSize == 'object') {
                        currentSize = currentSize[media]
                    }

                    for (let a = 0; a < column.children.length; a++) {
                        const child = column.children[a];


                        // column.children.forEach(child => {

                        let refComponent = this.props.componentsInfo.object[child.type]
                        let refSizes

                        if (refComponent) {
                            refSizes = refComponent.sizes
                        }


                        if (!refSizes) {
                            refSizes = {
                                min: { xs: 50, md: 20, lg: 10 },
                                suitable: { xs: 100, md: 100, lg: 100 },
                                max: { xs: 100, md: 100, lg: 100 },
                            }

                        }



                        childMin = (refSizes.min[media] ?? 0) > childMin ? (refSizes.min[media] ?? 0) : childMin
                        childSuitable = (refSizes.suitable[media] ?? 0) > childSuitable ? (refSizes.suitable[media] ?? 0) : childSuitable
                        childMax = (refSizes.max[media] ?? 100)

                        // console.log(child.id, newElement.id)
                        if (child.id == newElement.id) {
                            isNew = true
                            newLimits = { min: childMin, suitable: childSuitable, max: childMax }
                        }
                    }
                    // })

                    if (!currentSize) {
                        currentSize = 100
                    }

                    // totalMin = totalMin + childMin
                    // totalSuitable = totalSuitable + childSuitable

                    // if (column.id != newColumn.id) {
                    //     currentTotal = currentTotal + currentSize
                    // } else {
                    //     newColumnIndex = j
                    // }
                    //  else {
                    //     if (column.children.length == 1) {
                    //         newColumn = column.id
                    //     }
                    // }

                    childrenSizes[column.id] = { min: childMin, suitable: childSuitable, current: currentSize, isNew }
                    // childMax = childMax + (refSizes.max[media] ?? 0)


                    // })
                }

                // if (newColumn) {
                // console.log(media, currentTotal)
                // console.log(newLimits)
                let columnRows = []
                let currentColumnRowWidth = 0
                let currentColumnRow = []
                let newColumnRowIndex

                // if (currentTotal > 100) {


                for (let j = 0; j < sections.length; j++) {
                    let column = sections[j]
                    if (column.children?.length > 0) {
                        let nextColumn = sections[j + 1]
                        let currentSize = childrenSizes[column.id].current

                        if (column.id == newColumn.id) {


                            if (newElement.position == 'left' && (currentColumnRowWidth + (childrenSizes[nextColumn?.id]?.current ?? 0)) > 100) {
                                columnRows.push(currentColumnRow)
                                currentColumnRow = []
                                currentColumnRowWidth = 0
                            }

                            newColumnRowIndex = columnRows.length

                        } else {
                            if ((currentColumnRowWidth + currentSize) > 100) {
                                columnRows.push(currentColumnRow)
                                currentColumnRow = []
                                currentColumnRowWidth = 0

                            }
                            currentColumnRowWidth = currentColumnRowWidth + currentSize

                        }


                        currentColumnRow.push(column)

                        // console.log(column, currentSize)
                    }
                }

                columnRows.push(currentColumnRow)



                // console.log(columnRows)
                // console.log(newColumnRowIndex)


                // } else {

                // if (totalMin > 100) {

                //     // TO DO

                // } else {
                columnRows[newColumnRowIndex].forEach((column, k) => {

                    totalMin = totalMin + childrenSizes[column.id].min
                    totalSuitable = totalSuitable + childrenSizes[column.id].suitable

                    if (column.id != newColumn.id) {
                        currentTotal = currentTotal + childrenSizes[column.id].current
                    }

                })

                columnRows[newColumnRowIndex].forEach((column, k) => {

                    if (!finalSize[column.id]) {
                        finalSize[column.id] = {}
                    }

                    if (currentTotal + newLimits.min <= 100) {

                        if (column.id == newColumn.id) {
                            finalSize[column.id][media] = 100 - currentTotal
                        } else {
                            finalSize[column.id][media] = childrenSizes[column.id].current
                        }

                    } else {

                        finalSize[column.id][media] = Math.floor((100 / columnRows[newColumnRowIndex].length) * 100) / 100

                    }

                })

                // console.log("finalSize", finalSize)

                sections.forEach(column => {
                    if (finalSize[column.id]) {

                        if (!column.style) {
                            column.style = {}
                        }
                        if (!column.style.width) {
                            column.style.width = {}
                        }

                        for (const [key, value] of Object.entries(finalSize[column.id])) {
                            column.style.width[key] = value
                        }
                    }
                })
                // }
                // }
                // }

                // })
            }


            // console.log(finalSize)
            // section.children.forEach(column => {

            //     if (!column.style) {
            //         column.style = {}
            //     }
            //     column.style.width = finalSize[column.id]

            // })
        }
    }


    pushToContent(content, element, index, parents, target, targetIndex) {

        let foundIndex
        let finalElementIndex
        // console.log("------pushToContent")
        // console.log(JSON.parse(JSON.stringify(content)))
        // console.log(JSON.parse(JSON.stringify(target)))

        // console.log(target)
        // console.log(element)

        if (Array.isArray(content) && target) {
            content.forEach((element, nindex) => {
                if (element.id == target.id) {
                    foundIndex = nindex
                }
            });
        }


        // console.log("foundIndex", foundIndex)

        if (targetIndex != null) {

            content.splice(targetIndex, 0, element)

        } else {
            if (target) {
                // console.log("TP1")

                if (foundIndex == null) {
                    foundIndex = 0
                }

                // console.log("target?.position", target?.position)

                if (target?.position == 'top' || target?.position == 'left') {
                    content.splice(foundIndex, 0, element)
                } else {
                    content.splice(foundIndex + 1, 0, element)
                }

            } else {
                // console.log("TP2")

                content.push(element)
            }
        }

        // console.log('Final Content, ', content)



    }

    componentSelected = (e, section) => {
        e.stopPropagation()
        // if (!this.props.userView) {
        let selectedHiarchi = []
        section.parents.forEach(parent => {
            selectedHiarchi.push(parent.id)
        })

        let selectedParent = section.parents[section.parents.length - 1]

        this.setState({ selectedSection: section, selectedHiarchi, selectedParent })
        // }
    }


    renderInformationBox = (item, isSubForm) => {
        let type = item?.type

        if (item && type && this.props.componentsInfo.object[type]) {
            return (

                <div>
                    {/* {console.log('this.props.componentsInfo.object[type].headers',this.props.componentsInfo.object[type].headers)} */}
                    <div className="w-100 mt-2  pt-2" style={{ backgroundColor: '#fff', paddingBottom: '10px' }}>
                        <FormViewer ref={el => this.form = el} builderHeaders={true} headers={this.props.componentsInfo.object[type].headers} pages={this.props.pages} params={this.props.params} initData={item.information} data={item.information} width={this.props.width} errors={this.state.errors} formClass={'bordered-form'} inputClass={'bordered-input'} variables={this.props.variables} setFormStatus={this.setFormStatus} scrollToTop={this.scrollToTop} liveChange={this.changeInfoValue} colors={this.props.colors} />
                    </div>

                    {/* {this.props.componentsInfo.object[type].headers.map((headerProp, index) => {

                        if (!item.information) {
                            item.information = {}
                        }

                        let value = item.information[headerProp.key]
                        let info = Object.assign({}, headerProp.information)

                        info.options = item.information["options"] ? item.information["options"] : info.options

                        info.defaultValue = item.information["defaultValue"] ? item.information["defaultValue"] : info.defaultValue

                        let onChange = isSubForm ? this.changeSubInfoValue : this.changeInfoValue

                        const MyComponent = this.props.componentsInfoForm.components[headerProp.type]
                        if (MyComponent) {
                            return (
                                <div className={'w-100 form'} style={{}} key={index}>

                                    <label className={'mb-1 mrd-1 mld-1 mt-3 ' + (info.required ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, color: '#456', }}>{checkTranslation(info?.label)}</label>
                                    <div className={headerProp.information?.inputClass ?? "modern-input"}>

                                        <MyComponent changeValue={onChange} headerkey={headerProp.key} header={headerProp} information={info} data={value} options={headerProp.options} />
                                    </div>

                                </div>
                            )
                        }
                    })} */}
                </div>
            )
        }

    }


    showConfig = () => {
        this.sidebarView.open()
    }

    changeInfoValue = (data, init, key, value, extra, full, section, cb) => {
        // console.log("changeInfoValue")
        // console.log(value)
        // console.log(key)
        if (!init) {
            let content = this.state.content
            let selectedSection = section ?? this.state.selectedSection

            this.changeSectionInfo(content, selectedSection, key, value, 0)
            // console.log(content)
            this.setState({ content }, () => {
                if (cb) {
                    cb()
                }
            })
            // itemsList[this.state.selectedIndex].information[key] = value

            // this.changeItemsList(itemsList)
        }
    }

    changeSectionInfo(content, selectedSection, key, value, index) {
        // console.log("value ", value)

        // console.log("content ", content)

        if (Array.isArray(content) && index <= selectedSection.parents?.length) {
            let foundIndex
            let parentIndex

            content.forEach((element, sindex) => {
                if (element.id == selectedSection.id) {
                    foundIndex = sindex
                }

                if (element.id == selectedSection.parents[index]?.id) {
                    parentIndex = sindex
                }

                if (foundIndex != null) {
                    if (!content[foundIndex].information) {
                        content[foundIndex].information = {}
                    }
                    setObject(content[foundIndex].information, key, value)
                    // content[foundIndex].information[key] = value
                } else {
                    if (parentIndex != null) {
                        // console.log("HEREEEE!")
                        this.changeSectionInfo(content[parentIndex].children, selectedSection, key, value, index + 1)
                    }
                }
            });
        }
    }


    // changeSubInfoValue = (key, value) => {
    //     let itemsList = this.state.items

    //     itemsList[this.state.selectedIndex].information.headers[this.state.selectedSubIndex].information[key] = value

    //     this.changeItemsList(itemsList)
    // }

    duplicateElement = (section, parents, rowChildrenCount, columnChildrenCount) => {

        let newElement = JSON.parse(JSON.stringify(section))
        let id = nanoid()
        newElement.id = id

        let newParents = [...parents]
        let target = {}

        if (rowChildrenCount == 1) {
            newParents.pop()
            newParents[newParents.length - 1] = { id: nanoid(), type: 'row' }
            newParents.push({ id: nanoid(), type: 'column' })
            newElement.parents = newParents
            target = { id: newParents[newParents.length - 1]?.id, type: 'row', position: 'bottom' }
        } else {
            target = { id: newParents[newParents.length - 1]?.id, type: 'column', position: 'bottom' }
        }

        let targetParents = [...newParents]
        targetParents.pop()
        target.parents = targetParents

        // console.log(targetParents)
        // console.log(target)
        // console.log("newElement, ", newElement)

        let content = this.state.content

        this.doAddElement(content, newElement, newParents, target, null)
        this.setState({ selectedSection: null })
    }

    startMove = (e, section) => {
        // console.log("startMove")
        e.preventDefault()
        // console.log(e)
        this.mouseMoved(e)
        if (section && !this.state.movingSection) {
            this.setState({ movingSection: section, isDragging: true }, () => {
                // this.doRemoveElement(e, { ...section }, [...section.parents])

                window.addEventListener('mousemove', this.mouseMoved)
                window.addEventListener('mouseup', this.onDrop)
                // setTimeout(() => {
                //     window.removeEventListener('mousemove', this.mouseMoved)

                //     this.setState({ movingSection: null })

                // }, 100);




                this.onDragStartAction(null, section.type)
            })
        }
        // if (e.dataTransfer.setData) {
        //     e.dataTransfer.setData("type", section.type);
        //     e.dataTransfer.setData("dropType", "OLD");
        //     e.dataTransfer.setDragImage(new Image(), 0, 0);
        //     // e.dataTransfer.setDragImage(null, 0, 0);
        // } else {
        //     // e.dataTransfer.rowId = rowId;
        //     e.dataTransfer.type = section.type;
        //     e.dataTransfer.dropType = "OLD";
        // }
        // this.setState({selectedSection:null})
    }


    mouseMoved = (e) => {

        let bound = getBoundingClientRect(this.cornerIndicator)

        let top = e.clientY - bound.top + 10
        let left = e.clientX - bound.left + 10

        if (this.ghostView) {
            this.ghostView.style.top = top + 'px'
            this.ghostView.style.left = left + 'px'
        }

    }


    applyForm = () => {

        // console.log(this.state.content)
        this.sidebarView.hideModal()
    }


    changeSelectedTextEffects = () => {

    }



    changeSectionValue = (key, value, extra, section, cb) => {

        // console.log("key",key)
        // console.log("value",value)
        // console.log("section",section)


        this.changeInfoValue(null, false, key, value, extra, null, section, () => {
            if (cb) {
                cb()
            }
        })

    }


    setRowColSettings = (key, value, id, type, section, cb) => {


        if (key) {

            let content = this.state.content
            // let id

            // for (let i = section.parents.length - 1; i >= 0; i--) {
            //     const element = section.parents[i];
            //     if (!id && element.type == type) {
            //         id = element.id
            //     }

            // }

            // console.log(id, section.parents, 0, key, value)

            this.changeParentValue(content, id, section.parents, 0, key, value)

            // console.log(content)
            this.setState({ content }, () => {
                if (cb) {
                    cb()
                }
            })

        }


    }


    changeParentValue = (content, id, parents, index, key, value) => {

        let found = false
        let currentParent
        // console.log(parents)

        if (Array.isArray(content)) {
            content.forEach(element => {
                if (element.id == id) {
                    // console.log("FFFO")
                    setObject(element, key, value)
                    found = true
                }
                // console.log(parents,index)
                if (element.id == parents[index]?.id) {
                    currentParent = element
                }
            })
        }

        if (!found && currentParent) {
            let newIndex = index + 1
            this.changeParentValue(currentParent.children, id, parents, newIndex, key, value)
        }

    }



    updateTextEffectsStyleStatus = () => {

        // if (this.props.liveChange) {
        //     this.props.liveChange()
        // }
    }

    // setElementSettings = (index, key, value, section) => {
    //     let elements = this.state.elements

    //     if (elements[index]) {
    //         setObject(elements[index], key, value)
    //     }
    //     // console.log('elements', elements)
    //     this.setState({ elements })
    // }


    keepCurrentData = (section, data) => {
        let currentData = this.state.currentData
        currentData[section.id] = data

        // console.log(currentData)
        this.setState({ currentData })
    }


    removeElementClicked = (e, section, parents) => {
        e.stopPropagation();
        let content = this.state.content

        let bounds = this.findBounds(content)
        this.doRemoveElement(content, section, parents)

        this.setState({ content }, () => {
            let newBounds = this.findBounds(content)

            this.animateMove(bounds, newBounds)
            setTimeout(() => {
                this.setState({ content })
            }, 350);
        })

    }




    resizeMouseDown = (e, direction, section) => {
        // console.log('resizeMouseDown', direction, section);
        // e.stopPropagation()
        // e.preventDefault()
        let resizeColId = section.id
        // console.log(section)
        let resizableRef = this[resizeColId]
        this.setState({ currentResize: { ...section }, resizeColId, resizeUnit: '%' }, () => {
            if (resizableRef) {

                // console.log("resizableRef", resizableRef)
                const rect = getBoundingClientRect(resizableRef);

                e.persist()
                this.setState(
                    (prev) => {
                        return {
                            dragProps: {
                                ...prev.dragProps,
                                disabled: true
                            }
                        };
                    },
                    () => {

                        const corner = getBoundingClientRect(this.cornerDiv)

                        // console.log('rect', rect)
                        this.setState({ direction, corner }, () => {
                            this.setState(
                                {
                                    prevClient: {
                                        prevClientX: e?.clientX,
                                        prevClientY: e?.clientY
                                    },
                                    initialPosition: rect
                                },
                                () => {
                                    // window.addEventListener("mousemove", (ev) => {
                                    //     this.mouseMove(ev, direction);
                                    // });
                                    // 
                                    // // console.log('pppoooooossssss', this.state.initialPosition);

                                    window.addEventListener(
                                        "mousemove",
                                        this.resizeMouseMove
                                    );

                                    window.addEventListener("mouseup", this.resizeMouseup);
                                }
                            );
                        });
                    }
                );

            }
        })
    };

    resizeMouseMove = (e) => {

        // console.log('resizeMouseMove');

        e.preventDefault()
        e.stopPropagation()

        let resizableRef = this[this.state.resizeColId]
        let resizeUnit = this.state.resizeUnit
        let currentResize = this.state.currentResize


        if (resizableRef) {

            let windowRef = resizableRef
            // const bounds = getBoundingClientRect(resizableRef)


            const { height, width, margin, marginForWidth } = this.calculateResize(e)

            console.log('width', width, height, margin, marginForWidth)
            // const { height, position, width } = CalcResize(
            //     this.props.language,
            //     this.state.direction,
            //     { ...this.state.initialPosition },
            //     this.state.prevClient,
            //     e,
            // );

            // let height, position, width
            // console.log(width, height)
            // console.log("currentResize", currentResize)
            // console.log("width", width)

            if (width > 1 && height > 1) {
                if (height || width) {

                    // console.log("h1")
                    // windowRef.style.transform = `translate(${position.x}px, ${position.y}px)`
                    // windowRef.style.transform = `translateY(${position.y}px)`
                    // windowRef.style.height = height + '%'
                    // console.log("marginForWidth", marginForWidth)
                    if (marginForWidth) {
                        windowRef.style.width = `calc(${width + (resizeUnit ?? '%')} - ${marginForWidth}px)`
                    } else {
                        windowRef.style.width = width + (resizeUnit ?? '%')
                    }

                    // if (currentResize.type == 'column' || currentResize.type == 'row') {
                    //     // let resizableContainerRef = this['container-'+this.state.resizeColId]
                    //     // if(resizableContainerRef){
                    //     //     resizableContainerRef.style.margin = margin
                    //     // }
                    //     // windowRef.style.width.padding = margin

                    // } else {
                    windowRef.style.margin = margin
                    // }

                    // windowRef.style.background = 'red'
                    // console.log('heqmove2', windowRef.style.transform);
                }

            }
        }
    };


    calculateResize = (e) => {
        let currentResize = { ...this.state.currentResize }
        let resizeUnit = this.state.resizeUnit
        // console.log('calculateResize', currentResize.parents);

        let rootId = 'root'
        if (currentResize.parents && currentResize.parents.length > 0) {
            rootId = currentResize.parents[currentResize.parents.length - 1]?.id
        }

        // console.log('currentResize', currentResize);
        // console.log('this[rootId]', this[rootId]);


        let rootBounds = getBoundingClientRect(this[rootId])

        let initialPosition = this.state.initialPosition

        // console.log('rootBounds', rootBounds);
        // console.log('initialPosition', initialPosition);

        let direction = this.state.direction
        let mousePosition = { x: e?.clientX, y: e?.clientY }
        let initialMargin = currentResize?.style?.margin
        let initLeftMargin

        if (initialMargin && typeof initialMargin == 'object') {
            initialMargin = initialMargin[this.state.currentMedia]
        }


        let newData = { width: initialPosition.width, height: initialPosition.height, margin: initialMargin, }

        // console.log('newData', newData);
        // console.log('mousePosition.x', mousePosition.x,initialPosition.left);


        if (direction == 'right' || direction == 'se') {
            newData.width = mousePosition.x - initialPosition.left
        }

        if (direction == 'left') {
            // console.log(initialMargin)
            newData.margin = this.changeMarginValue(initialMargin, mousePosition.x - initialPosition.left, 3)


            // console.log('newData.margin', newData.margin, initialMargin, initialPosition.width, newData.width);

            // console.log('initialMargin', initialMargin);
            let leftMargin = newData.margin ? newData.margin.split(' ') : ['0px']

            leftMargin = leftMargin[leftMargin.length - 1]
            // console.log('leftMargin', initialMargin, leftMargin)
            if (leftMargin) {

                leftMargin = Number(leftMargin.replace('px', '')) ?? 0

                newData.marginForWidth = leftMargin
                // console.log('initialMargin', newData.marginForWidth, initialMargin)

                // if (currentResize.type != 'column' && currentResize.type != 'row') {

                // newData.width = newData.width + leftMargin

                // }
            }

            initLeftMargin = initialMargin ? initialMargin.split(' ') : ['0px']

            initLeftMargin = initLeftMargin[initLeftMargin.length - 1]
            // console.log('leftMargin', initialMargin, leftMargin)
            if (initLeftMargin) {

                initLeftMargin = Number(initLeftMargin.replace('px', '')) ?? 0

                // newData.marginForWidth = leftMargin
                // console.log('initialMargin', initLeftMargin)

                // if (currentResize.type != 'column' && currentResize.type != 'row') {

                // newData.width = newData.width + leftMargin

                // }
            }
            // }
            // newData.width = `${newData.width}` - `${leftMargin}px`
            // if (leftMargin) {
            //     console.log('leftMargin', leftMargin)
            //     newData.width =  newData.width - (Number(leftMargin.replace('px', '')) ?? 0)
            // }
        }

        if (direction == 'top') {
            newData.margin = this.changeMarginValue(initialMargin, mousePosition.y - initialPosition.top, 0)
        }
        // console.log(newData)


        // if (newData.width < 1) {
        //     newData.width = 1
        // }

        if (newData.width < 0) {
            newData.width = 1
        }

        if (resizeUnit == '%') {
            // console.log('resizeUnit', newData.width, rootBounds.width, initLeftMargin);
            newData.width = (newData.width + (initLeftMargin ?? 0)) / rootBounds.width
            if (newData.width > 1) {
                newData.width = 1
            }
            newData.width = Math.round(newData.width * 1000) / 10
        } else {
            newData.width = Math.round(newData.width * 100) / 100
        }

        // console.log(newData.width)

        // console.log('resizeMouseMove', direction, mousePosition, initialPosition, rootBounds);
        // console.log('newData', newData);

        return newData
    }



    changeMarginValue = (value, newValue, index) => {

        // let currentResize = this.state.currentResize
        let finalValue
        let newMargin = value //? (typeof value == 'object' ? value[this.state.currentMedia] : value) : '0px 0px 0px 0px'
        if (!newMargin || typeof newMargin != 'string') {
            newMargin = '0px 0px 0px 0px'
        }
        // console.log(newMargin)
        newMargin = newMargin.split(' ')
        let tempValue = Number(newMargin[index].replace('px', '').replace("%", ''))
        // console.log(tempValue)
        newMargin[index] = tempValue + newValue
        if (newMargin[index] < 0) {
            newMargin[index] = 0
        }
        newMargin[index] = Math.round(newMargin[index])
        newMargin[index] = newMargin[index] + 'px'
        newMargin = newMargin.join(' ')
        finalValue = newMargin


        // console.log("changeMarginValue",value,newValue,finalValue)

        // if (value && typeof value == 'object') {
        //     finalValue = value
        //     finalValue[this.state.currentMedia] = newMargin
        // }

        return finalValue


    }


    resizeMouseup = (e, direction) => {
        // console.log('resizeMouseup');

        // e.stopPropagation();
        // e.preventDefault();
        let resizableRef = this[this.state.resizeColId]
        let resizeUnit = this.state.resizeUnit
        let currentResize = this.state.currentResize

        if (resizableRef) {

            const { height, width, margin, marginForWidth } = this.calculateResize(e)

            // console.log(height, width, margin, marginForWidth)


            // if (this.state.currentResize?.type == 'column') {
            //     this.setRowColSettings('style.width.' + this.state.currentMedia, width, null, 'column', this.state.currentResize, () => {
            //         console.log(this.state.content)
            //     })
            // }
            // console.log('style.width.' + this.state.currentMedia, width,currentResize)
            // console.log(this.state.content)
            let key = 'style.width.' + this.state.currentMedia


            this.changeParentValue(this.state.content, currentResize.id, currentResize.parents, 0, key, width)

            setTimeout(() => {
                key = 'style.margin.' + this.state.currentMedia
                this.changeParentValue(this.state.content, currentResize.id, currentResize.parents, 0, key, margin)
            }, 2);

            setTimeout(() => {

                this.getComponentsSize()

            }, 100);
            // this.changeSectionValue('style.width.' + this.state.currentMedia, width, null, this.state.currentResize, () => {
            //     console.log(this.state.content)
            // })


            // const rect = resizableRef.getBoundingClientRect();

            // console.log(rect)

            // let diffrenece = 0
            // if (this.props.language == 'fa') {
            //     diffrenece = -(window.innerWidth - rect.right)

            // } else {
            //     diffrenece = rect.left
            // }
            // console.log('heqmovedef', diffrenece, rect);
            // this.setState(
            //     (prev) => {
            //         // 
            //         // 
            //         return {
            //             dragProps: {
            //                 ...prev.dragProps,
            //                 disabled: false,
            //                 position: { x: diffrenece, y: rect.y },
            //                 width: rect.width,
            //                 height: rect.height
            //             }
            //         };
            //     }, () => {
            //         this.setState((prev) => {
            //             // 
            //             // let windows = JSON.parse(JSON.stringify(this.props.user.windows))
            //             // windows[this.props.id].width = this.state.dragProps.width
            //             // windows[this.props.id].height = this.state.dragProps.height
            //             // windows[this.props.id].defaultPosition.x = this.state.dragProps.position.x
            //             // windows[this.props.id].defaultPosition.y = this.state.dragProps.position.y
            //             // // console.log('pppoooooossssss', windows[this.props.id]);
            //             // // console.log('pppoooooossssss', this.props.user.windows[this.props.id]);
            //             // // this.props.actions.changeWindow(windows)

            //             // // // console.log('hereeeeeedouuppppw', this.state.dragProps);

            //             // return {
            //             //     dragProps: {
            //             //         ...prev.dragProps,
            //             //         position: null
            //             //     }
            //             // };
            //         })
            //     }
            // );
            // 
            // window.removeEventListener("mousemove", () => {});
            // window.removeEventListener("mousemove", () => {});
            window.removeEventListener("mousemove", this.resizeMouseMove);
            window.removeEventListener("mouseup", this.resizeMouseup);
            // this.resizeComponent()
        }
        // window.removeEventListener("mouseup", () => {});
    };

    changeMedia = (media) => {
        this.props.changeMedia(media, () => {
            this.checkWidth()
        })
        // this.setState({ currentMedia: media })
    }





    actionClicked = (info, data, extra) => {

        this.functionsHandler('page', info.function, data, extra, info)

    }

    parentSelected = (item, select, hover) => {
        // console.log("parentSelected", item)
        this.setState({ selectedParent: item })
    }


    calcDivWidth = (style) => {

        let width = (style.width && typeof style.width == 'object') ? `${style.width[this.state.currentMedia]}%` : style.width ?? '100%'

        if (style.margin && width) {

            // console.log((width))
            width = JSON.parse(JSON.stringify(width))


            // console.log(style.margin, this.state.currentMedia)

            let margin
            if (style.margin && typeof style.margin == 'object' && style.margin[this.state.currentMedia]) {
                margin = JSON.parse(JSON.stringify(style.margin[this.state.currentMedia]))
                // margin = style.margin[this.state.currentMedia]
            }
            // console.log("margin", margin)


            if (margin && typeof margin == 'string') {
                margin = margin.split(' ')
                let marginLeft = margin[margin.length - 1] ? margin[margin.length - 1].replace('px', '') : 0
                width = `calc(${width} - ${marginLeft}px)`
                // width = `calc(${width} )`

            }

            // console.log("width", width)
        }
        return width
    }


    renderDiv = (section, parents, index, rowChildrenCount, columnChildrenCount) => {

        if (Array.isArray(section?.children)) {

            let rowDropables = [
                // { key: 'top', left: 0, width: '100%', top: 0, height: 10, backgroundColor: '#007aff10' },
                { key: 'bottom', left: 0, width: '100%', bottom: 0, height: 10, backgroundColor: 'transparent' },
                // { key: 'left', left: 0, width: 10, top: 0, height: '100%', backgroundColor: '#ee505010' },
                // { key: 'left', right: 0, width: 10, top: 0, height: '100%', backgroundColor: '#ee505010' },

            ]

            let columnDropables = [
                // { key: 'top', left: 0, width: '100%', top: 0, height: 10, backgroundColor: '#007aff10' },
                // { key: 'bottom', left: 0, width: '100%', bottom: 0, height: 10, backgroundColor: '#007aff10' },
                { key: 'left', left: 0, width: 5, top: 0, height: '100%', backgroundColor: 'transparent' },
                { key: 'right', right: 0, width: 5, top: 0, height: '100%', backgroundColor: 'transparent' },

            ]
            let style = section.style ?? {}
            let mediaWidth = this.calcDivWidth(style)
            let mediaMargin = style.margin ? `${style.margin[this.state.currentMedia]}` : null

            let maxWidth = style.maxWidth ? (style.maxWidth + (style.maxWidthUnit ?? '%')) : null

            if (style.container == true && (!maxWidth || maxWidth > this.state.containerMaxWidth)) {

                maxWidth = this.state.containerMaxWidth
            }


            // let activeForResize = this.state.selectedHiarchi && this.state.selectedHiarchi.includes(section.id)//this.state.activeForResize?.id == section.id
            let activeForResize = this.state.selectedSection && this.state.selectedParent?.id == section.id//this.state.selectedHiarchi && this.state.selectedHiarchi.includes(section.id)//this.state.activeForResize?.id == section.id

            section.parents = parents
            // console.log("mediaWidth",mediaWidth)

            return (

                <>

                    <div ref={el => this[section.id] = el} key={section.id} className={'position-relative d-flex ' + (section.id)} style={{ width: mediaWidth, maxWidth: maxWidth, padding: style.margin, border: style.border, borderRadius: style.borderRadius, margin: mediaMargin ?? 0, boxSizing: 'border-box', minHeight: 15, marginLeft: ((style.container == true && section.type == 'row') ? 'auto' : null), marginRight: ((style.container == true && section.type == 'row') ? 'auto' : null) }} >
                        {/* border: (this.state.isDragging || activeForResize) ? "px dashed #ddd" : '0px solid transparent', */}
                        <div ref={el => this["container-" + section.id] = el} className={'flex-1 ' + (section.type == 'row' ? ' section-row d-flex flex-wrap  ' : ' section-column d-flex flex-column')} style={{ outlineOffset: 0, padding: style.padding ?? null, boxShadow: style.boxShadow, background: style.background, borderRadius: style.borderRadius, outline: (this.props.editMode && style.margin && activeForResize) ? `${style.margin} solid #f0f0f0` : null }}>
                            {section?.children.map((element, eIndex) => {

                                let newParents = [...parents]
                                newParents.push({ id: section.id, type: section.type, style: section.style })
                                return (
                                    this.renderDiv(element, [...newParents], eIndex, (section.type == 'row' ? section?.children?.length : rowChildrenCount), (section.type == 'column' ? section?.children?.length : columnChildrenCount))
                                )
                            })}


                            {this.state.isDragging && section.type == 'row' && !section.temp && rowDropables.map((dropable, dIndex) => {
                                return (
                                    <div className={'dragable mx-2'} onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: 'row', parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: 'row', parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ zIndex: 10, position: 'absolute', top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, width: 'calc(100% - 16px)', height: '20%', minHeight: 10, maxHeight: 20, backgroundColor: dropable.backgroundColor, }}>
                                        {/* border: '1px dashed #007aff20' */}

                                    </div>
                                )
                            })}



                            {this.state.isDragging && section.type == 'column' && !section.temp && columnDropables.map((dropable, dIndex) => {
                                return (
                                    <div key={dIndex} className={'dragable'} onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: 'column', parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: 'column', parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ zIndex: 11, position: 'absolute', top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: 'calc(100% - 16px)', width: '20%', minWidth: 10, maxWidth: 20, backgroundColor: dropable.backgroundColor, }}>

                                    </div>
                                )
                            })}




                        </div>


                        {(activeForResize && this.props.editMode) && (
                            <div className='h-100 w-100' style={{ position: 'absolute', zIndex: 2, pointerEvents: 'none', boxShadow: 'inset 0px 0px 0px 1px #007aff' }}>

                            </div>
                        )}


                        {this.props.editMode && !this.state.isDragging && activeForResize && this.state.resizeArrows.map((arr, index) => {
                            const { direction, style } = arr;
                            return (
                                <div
                                    draggable={false}
                                    key={index}
                                    className={` resizer ${direction}`}
                                    onMouseDown={(e) =>

                                        this.resizeMouseDown(e, direction, section)
                                    }
                                    style={style}
                                // onMouseUp={(e) =>
                                //     this.mouseup(e, direction)
                                // }
                                ></div>
                            );
                        })}

                    </div>



                </>
            )

        } else {
            if (section.type == 'dropZone') {
                let style = section.style ?? {}
                let mediaWidth = (style.width && typeof style.width == 'object') ? `${style.width[this.state.currentMedia]}%` : style.width ?? '100%'

                return (
                    <div key={section.id} className='p-1' style={{ width: mediaWidth, pointerEvents: 'none' }} >
                        <div className='dropZone' style={{ borderRadius: 4, minHeight: 30, backgroundColor: '#007aff10', border: '1px dashed #007aff' }}>
                            {/* <p>Ghost</p> */}
                        </div>
                    </div>
                )
            } else {

                let dropables = []
                // let handlers = [
                //     { key: 'bottom', left: 0, width: '100%', bottom: -2, height: 4, backgroundColor: '#007aff' },
                //     { key: 'top', left: 0, width: '100%', top: -2, height: 4, backgroundColor: '#007aff' },
                //     { key: 'left', left: -2, width: 4, top: 0, height: '100%', zIndex: 1, backgroundColor: '#007aff' },
                //     { key: 'right', right: -2, width: 4, top: 0, height: '100%', zIndex: 1, backgroundColor: '#007aff' },
                // ]

                let colStyle = (section.parents ? section.parents[section.parents.length - 1].style : {}) ?? {}



                if (rowChildrenCount > 1) {
                    dropables.push({ key: 'bottom', left: 0, width: 'calc(100% - 20px)', bottom: 0, height: 20, backgroundColor: 'transparent' },)
                    dropables.push({ key: 'top', left: 0, width: 'calc(100% - 20px)', top: 0, height: 20, backgroundColor: 'transparent' })
                }

                if (columnChildrenCount > 1) {
                    dropables.push({ key: 'left', left: 0, width: 20, top: 0, height: '100%', zIndex: 1, backgroundColor: 'transparent' },)
                    dropables.push({ key: 'right', right: 0, width: 20, top: 0, height: '100%', zIndex: 1, backgroundColor: 'transparent' },)
                }


                let Component = this.props.componentsInfo.components[section.type] ?? null
                let data = section?.information
                let header = section ?? { key: section.id, id: section.id, information: {} }
                if (!header.information) {
                    header.information = {}
                }
                section.parents = parents
                let isMovingSection = this.state.movingSection?.id == section.id
                let isSelected = this.state.selectedSection?.id == section.id
                let activeForResize = (!this.state.selectedParent && this.state.selectedSection?.id == section.id) || (this.state.selectedParent?.id == section.id)
                // let activeForResize = this.state.activeForResize?.id == section.id
                let style = section.style ?? {}
                let mediaWidth = this.calcDivWidth(style)                //(style.width && typeof style.width == 'object') ? `${style.width[this.state.currentMedia]}%` : style.width ?? '100%'
                let mediaMargin = style.margin ? `${style.margin[this.state.currentMedia]}` : null


                return (
                    <div key={section.id} ref={el => this[section.id] = el} className={'element  position-relative  d-flex ' + " mb-0 p-0  "} style={{ margin: mediaMargin, width: mediaWidth, minHeight: 15, opacity: isMovingSection ? '0.5' : 1, border: style.border, borderRadius: style.borderRadius, }} >



                        {this.props.editMode && isSelected && (
                            <ComponentFloatConfig
                                width={this.props.width}
                                header={header}
                                section={section}
                                editorId={section.id}
                                widgetType={section.type}
                                element={section}
                                fields={this.props.fields}
                                params={this.props.params}
                                variables={this.props.variables}
                                parents={parents}
                                parentSelected={this.parentSelected}
                                setRowColSettings={(id, key, value, type) => this.setRowColSettings(key, value, id, type, section)}
                                setElementSettings={(index, key, value) => this.changeSectionValue(key, value, null, section)}
                                showConfig={(e) => { e.stopPropagation(); this.showConfig() }}
                                insertText={(text, id) => insertTextInEditor(text, id)}
                                changeSelectedTextEffects={(effectType, id) => changeSelectedTextEffects(effectType, id, this.updateTextEffectsStyleStatus)}
                                startMove={(e) => { e.stopPropagation(); this.startMove(e, section) }}
                                doRemoveElement={(e) => { this.removeElementClicked(e, section, parents,) }}
                                duplicateElement={(e) => { e.stopPropagation(); this.duplicateElement(section, parents, rowChildrenCount, columnChildrenCount) }}
                            />
                        )}


                        {Component && (
                            <div className={'builder-component-container main-container flex-1 d-flex h-100 flex-column ' + (this.props.editMode ? 'hover-effect' : '')} id={header.key} ref={el => this["cc-" + header.key] = el} onClick={(e) => this.componentSelected(e, section)} style={{ width: 0, border: this.props.editMode ? (activeForResize ? '1px solid #007aff' : null) : null, }}>

                                <div className='flex-1 d-flex flex-column h-100 ' style={{ border: colStyle.border, justifyContent: colStyle?.alignItems, alignItems: colStyle?.justifyContent, pointerEvents: this.props.editMode ? (isSelected ? "all" : 'none') : null }}>

                                    <Component actions={this.state.actions} page={this.props.page} isDragging={this.state.isDragging} permissions={this.props.permissions} section={section} editorId={section.id} changeValue={(key, value, extra) => this.changeSectionValue('content', value, extra, section)} data={data} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} width={this.state.componentSizes[header.key]?.width ?? this.props.width} height={this.state.componentSizes[header.key]?.height ?? this.props.height} params={this.props.params} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} addNewWindow={this.props.addNewWindow} baseUrl={this.props.baseUrl ? [...this.props.baseUrl] : null} windowData={this.props.windowData} colors={this.props.colors} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} userView={this.props.userView} editMode={this.props.editMode} functionsHandler={this.functionsHandler} keepCurrentData={this.keepCurrentData} currentData={this.state.currentData[section.id]} actionClicked={this.actionClicked} fullData={this.props.fullData} justifyContent={colStyle?.justifyContent} />

                                </div>
                            </div>
                        )}

                        {!isMovingSection && this.state.isDragging && dropables.map((dropable, dIndex) => {
                            return (
                                <div key={dIndex} className='dragable' onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: section.type, information: section.information, parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: section.type, information: section.information, parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ position: 'absolute', zIndex: dropable.zIndex, top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor, zIndex: 20 }}>

                                </div>
                            )
                        })}


                        {this.props.editMode && !this.state.isDragging && activeForResize && this.state.resizeArrows.map((arr, index) => {
                            const { direction, style } = arr;
                            return (
                                <div
                                    draggable={false}
                                    key={index}
                                    className={` resizer ${direction}`}
                                    onMouseDown={(e) =>

                                        this.resizeMouseDown(e, direction, section)
                                    }
                                    style={style}
                                // onMouseUp={(e) =>
                                //     this.mouseup(e, direction)
                                // }
                                ></div>
                            );
                        })}


                    </div>
                )
            }
        }
    }




    functionsHandler = (type, name, data, extra, info) => {


        // console.log(type, name, data, extra, info)

        if ((!type || type == 'page') && typeof this[name] == 'function') {

            this[name](data, extra, info)

        } else if (this.props.functionsHandler) {

            this.props.functionsHandler(type, name, data, extra, info)
        }

    }


    doPrint = (prop, extra, info) => {

        this.printRef.handlePrint();
        // console.log(prop, extra, info)
        // console.log(`.page-container.${this.state.pageId}`)
        // const element = document.querySelector(`.page-container.${this.state.pageId}`);
        // console.log(element)
        // if (element) {
        //     const printWindow = window.open('', '', 'width=800,height=600');

        //     if (printWindow) {
        //         printWindow.document.write(`
        //         <html>
        //           <head>
        //             <title>Print</title>
        //             <style>
        //               /* Optional: styles for print */
        //               body {
        //                 font-family: sans-serif;
        //                 padding: 20px;
        //               }
        //             </style>
        //           </head>
        //           <body>
        //             ${element.outerHTML}
        //           </body>
        //         </html>
        //       `);

        //         printWindow.document.close();
        //         printWindow.focus();
        //         // printWindow.print();
        //         // printWindow.close();
        //     }
        // }

    }




    savePDF = (prop, extra, info) => {

        console.log("SAVE AS PDF")
        if (this.root) {
            const input = this.root;
            html2canvas(input, { scale: 2, useCORS: true }).then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('p', 'mm', 'a4');

                const margin = 10;

                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

                const imgWidth = pdfWidth - margin * 2;
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

                pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
                pdf.save('download.pdf');
            });
        }

    }



    manualTrigger = (fullData, extra, info) => {


        let body = {
            trigger: info.trigger,
            triggerData: info.triggerData,
        }

        // console.log(body)


        HttpServices.request("callManualTrigger", body, (fetchResult, fetchError, status) => {

            if (fetchError) {

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }


            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.requestSubmittedSuccessfully' })


        })

    }


    downloadFile = (fullData, extra, info) => {


        let data = textVariableReplacer(fullData, info?.source, extra?.headers, 'Current Record')

        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }


        saveAs(imageAddress(data))

    }




    openWindow = (prop, extra, info) => {

        // console.log('openWindow', prop, extra, info)
        // return
        let newLink = this.props.baseUrl.splice(2)
        newLink.push(info.page)
        newLink.push(prop._id)

        this.props.changeWindowLink(newLink)


    }






    render() {
        // console.log('vcontent',this.state.content)
        return (
            <div className={'PageBuilderMain page-container position-relative w-100 h-100 d-flex window-content-radius  ' + (this.state.pageId) + (this.state.movingSection ? ' lockUserSelect' : '')}>

                <div ref={el => this.cornerDiv = el} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1 }}></div>



                <SidebarView hight={"100%"} width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <div className='w-100 overflow-auto h-100 pb-4'>
                        <div className='w-100 flexcb px-2 py-1 ' style={{ position: 'sticky', top: 0, borderBottom: '#f7f7f7 1px solid', backgroundColor: '#fcfcfc', zIndex: 5, }}>
                            <div className=" pld-3 " >
                                <p className=" font-bold">{translate('Field Options')}</p>
                            </div>

                            <div>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.applyForm}
                                    title={checkTranslation('Apply')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={this.props.colors?.textColor}
                                    invert={this.props.colors?.iconInvert}
                                    bg={this.props.colors?.background}
                                />
                            </div>
                        </div>
                        <div className='px-1'>
                            {this.renderInformationBox(this.state.selectedSection)}
                        </div>
                    </div>
                </SidebarView>

                <div className={'w-100 h-100  ' + (this.props.noScroll ? "" : "scroll-no-scrollbar")} style={{ padding: this.props.padding }}>


                    <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.cornerIndicator = el)}></div>


                    {(!this.state.content || this.state.content.length == 0) && !this.state.dropZone && (
                        <div onDrop={(e) => this.onDrop(e)} onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => this.onDragEnter(e)} onDragLeave={(e) => this.onDragLeave(e)} className='w-100 h-100 flexcc py-5 flex-column br-20' style={{ border: "1px dashed #ddd" }}>
                            {/* <img className='no-user-select' style={{ pointerEvents: 'none' }} draggable={false} width={150} src='/assets/icons/pagebuilder/pageBuilder.svg' /> */}
                            <img className='no-user-select' style={{ pointerEvents: 'none' }} draggable={false} width={100} src='/assets/icons/pagebuilder/drag.svg' alt='' />
                            <p className='font-size-12 mt-3 weight-300' style={{ color: "#444", pointerEvents: 'none' }}>{translate('Drag and drop elements here')}</p>
                        </div>
                    )}


                    {/* {console.log(this.state.content)} */}
                    {((this.state.content && this.state.content.length > 0) || this.state.dropZone) && (
                        <>
                            <ReactToPrint
                                ref={el => this.printRef = el}
                                content={() => this.root}
                                copyStyles={true}
                                pageStyle={`
                                @page {
                                    size: A4 ;
                                    margin: 0;
                                    }
                                    body{
                                        font-family: "iranyekan", sans-serif !important;
                                    }
                                    body > *:first-child {
                                    box-sizing: border-box;
                                      margin: 0 auto;
                                        max-width: 800px;
                                        width: 100%;
                                        direction:${this.state.isRTL ? 'rtl' : 'ltr'};

                                        
                                    }

                                    * {
                                    box-sizing: border-box;
                                    }
                            `}
                            />

                            <div onClick={() => this.setState({ selectedSection: null })} ref={el => this.root = el} className={'root w-100 ' + (this.props.cardMode ? "" : "pb-5")} style={{ minHeight: this.props.height, }} onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => { e.preventDefault() }} onDrop={(e) => this.onDrop(e, null)} >
                                {/* {console.log('content::', this.state.content)} */}
                                {this.state.colView && this.state.content?.map((div, rIndex) => {
                                    return (
                                        this.renderDiv(div, [])
                                    )
                                })}


                            </div>
                        </>
                    )}







                    {this.state.movingSection && (
                        <div ref={el => this.ghostView = el} className='br-6 px-3 py-2 flexc' style={{ zIndex: 10, position: 'fixed', top: 0, left: 0, border: '1px solid #eee', boxShadow: '0px 0px 50px #10101040', backgroundColor: '#fff' }}>
                            <img height={24} src='/assets/icons/useful/input.png' />
                            <p className='pld-2 text-small' style={{ color: '#202020' }}>{checkTranslation(this.state.movingSection?.type)}</p>
                        </div>
                    )}






                </div>


                {/* {this.state.extraPage && (
                    <div className='position-absolute top-0 w-100 flex-1 ' style={{ backgroundColor: '#fff' }}>

                        <PageViewer baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={this.props.colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} setHeader={this.props.setHeader} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />

                    </div>
                )} */}



            </div>
        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(PageBuilderMain)
